export const HOTEL_All_ACTION = "HOTEL_All_ACTION";
export const HOTEL_All_SUCCESS = "HOTEL_All_SUCCESS";
export const HOTEL_All_FAIL = "HOTEL_All_FAIL";

export const HOTEL_LIST_ACTION = "HOTEL_LIST_ACTION";
export const HOTEL_LIST_SUCCESS = "HOTEL_LIST_SUCCESS";
export const HOTEL_LIST_FAIL = "HOTEL_LIST_FAIL";

export const HOTEL_DETAIL_ACTION = "HOTEL_DETAIL_ACTION";
export const HOTEL_DETAIL_SUCCESS = "HOTEL_DETAIL_SUCCESS";
export const HOTEL_DETAIL_FAIL = "HOTEL_DETAIL_FAIL";

export const HOTEL_FAIL = "HOTEL_FAIL";
export const HOTEL_DETAIL_UPDATE_ACTION = "HOTEL_DETAIL_UPDATE_ACTION";
export const HOTEL_DETAIL_CREATE_ACTION = "HOTEL_DETAIL_CREATE_ACTION";

export const HOTEL_CREATE_TRANSLATE_ACTION = "HOTEL_CREATE_TRANSLATE_ACTION";
export const HOTEL_CREATE_TRANSLATE_SUCCESS = "HOTEL_CREATE_TRANSLATE_SUCCESS";

export const HOTEL_UPDATE_TRANSLATE_ACTION = "HOTEL_UPDATE_TRANSLATE_ACTION";
export const HOTEL_UPDATE_TRANSLATE_SUCCESS = "HOTEL_UPDATE_TRANSLATE_SUCCESS";

export const HOTEL_DELETE_TRANSLATE_ACTION = "HOTEL_DELETE_TRANSLATE_ACTION";
export const HOTEL_DELETE_TRANSLATE_SUCCESS = "HOTEL_DELETE_TRANSLATE_SUCCESS";

export const HOTEL_TAG_GROUP_DETAIL_SKU_ACTION = "HOTEL_TAG_GROUP_DETAIL_SKU_ACTION";
export const HOTEL_TAG_GROUP_DETAIL_SKU_SUCCESS = "HOTEL_TAG_GROUP_DETAIL_SKU_SUCCESS";

export const HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION = "HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION";
export const HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS = "HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS";

export const HOTEL_ALL_ACTIVE_ACTION = "HOTEL_ALL_ACTIVE_ACTION";
export const HOTEL_ALL_ACTIVE_SUCCESS = "HOTEL_ALL_ACTIVE_SUCCESS";
export const HOTEL_ALL_ACTIVE_FAIL = "HOTEL_ALL_ACTIVE_FAIL";

export const CLEAR_CACHE_ACTION = "CLEAR_CACHE_ACTION";
export const CLEAR_CACHE_SUCCESS = "CLEAR_CACHE_SUCCESS";

export const RATE_LIST_COMPARE_ACTION = "RATE_LIST_COMPARE_ACTION";
export const RATE_LIST_COMPARE_SUCCESS = "RATE_LIST_COMPARE_SUCCESS";
export const RATE_LIST_COMPARE_FAIL = "RATE_LIST_COMPARE_FAIL";
export const RATE_LIST_COMPARE_CREATE_ACTION = "RATE_LIST_COMPARE_CREATE_ACTION";
export const RATE_LIST_COMPARE_UPDATE_ACTION = "RATE_LIST_COMPARE_UPDATE_ACTION";
export const RATE_LIST_COMPARE_DELETE_ACTION = "RATE_LIST_COMPARE_DELETE_ACTION";
